import React, { Fragment } from 'react';
import { Transition, Button, Link } from 'components';
import css from './short.scss';

export function ThankYou(props) {
  return (
    <Transition in={props.active} mountOnEnter unmountOnExit classNames={css.locals} timeout={500}>
      <div className={[css.form, css['appear' + props.status]].join(' ')}>
        <h4>Your message has been sent!</h4>
        <p>We will reply within 24 hours.</p>
        <p><Button to="/">Return</Button></p>
      </div>
    </Transition>
  );
}
